import { render, staticRenderFns } from "./rfid-audit-list.vue?vue&type=template&id=6c1ec928&scoped=true&"
import script from "./rfid-audit-list.vue?vue&type=script&lang=js&"
export * from "./rfid-audit-list.vue?vue&type=script&lang=js&"
import style0 from "./rfid-audit-list.vue?vue&type=style&index=0&id=6c1ec928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1ec928",
  null
  
)

export default component.exports